import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'navy';
}
export function Section({
  children,
  className = '',
  id,
  background = 'default'
}: SectionProps) {
  const backgrounds = {
    default: 'bg-brand-cream-50',
    white: 'bg-white',
    navy: 'bg-brand-navy-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 relative overflow-hidden ${backgrounds[background]} ${className}`} data-id="element-199">
      {/* Add subtle grain texture to all sections for that paper feel */}
      <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none mix-blend-multiply" data-id="element-200"></div>
      {children}
    </section>;
}